import BaseAPI from "./BaseAPI";
import { checkRoute } from "../routes";

export default class CheckAPI extends BaseAPI {
    // `api` is the parent DataAPI instance — injected so we can reach sibling
    // entity APIs (e.g. CheckForm) without importing the API singleton
    // (which would create a load-time cycle apiInstance → DataAPI → CheckAPI).
    constructor(emitterInstance, api) {
        super(emitterInstance, checkRoute, "check");
        this.api = api;
    }

    async Add(data, idempotencyKey = null, actingUserId = null, { emitEvent = true } = {}) {
        const headers = {};
        if (idempotencyKey) headers["Idempotency-Key"] = idempotencyKey;
        if (actingUserId) headers["X-Acting-User-ID"] = actingUserId;
        const result = await this._request("post", this._url(), data, { headers });
        if (emitEvent) this._emit("add", result.id);
        return result;
    }

    async Update(id, data, actingUserId = null, { emitEvent = true } = {}) {
        const headers = actingUserId ? { "X-Acting-User-ID": actingUserId } : {};
        const result = await this._request("put", this._url(`/${id}`), data, { headers });
        if (emitEvent) this._emit("update", id);
        return result;
    }

    async GetByIDFull(id) {
        const check = await this._request("get", this._url(`/${id}`));
        // Without this, GetByID("") requests the trailing-slash URL, which
        // Fiber's non-strict routing resolves to the LIST endpoint — an
        // array whose .schema is undefined, crashing JSON.parse below.
        if (!check.form_id) {
            throw new Error(`Check ${id} has no form_id`);
        }
        const checkForm = await this.api.CheckForm.GetByID(check.form_id);
        return {
            schema: JSON.parse(checkForm.schema),
            ui_schema: JSON.parse(checkForm.ui_schema),
            data: JSON.parse(check.data),
            form_id: check.form_id,
            schedule_id: check.schedule_id,
            schedule_due_at: check.schedule_due_at,
            complete_schedule: check.complete_schedule,
            form_title: checkForm.title,
            date: check.date,
            signed: check.signed,
            created_by: check.created_by,
            completed_by: check.completed_by,
            approved_by: check.approved_by,
            tags: check.tags || []
        };
    }
}
